module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('l-map', {
    style: ('height: ' + this.height + '; width: ' + this.width + ';'),
    attrs: {
      "zoom": _vm.zoomLevel,
      "center": _vm.center,
      "options": _vm.mapOptions
    },
    on: {
      "update:center": _vm.centerUpdate,
      "update:zoom": _vm.zoomUpdate
    }
  }, [_c('l-tile-layer', {
    attrs: {
      "url": _vm.url,
      "attribution": _vm.attribution
    }
  }), _vm._v(" "), (_vm.captionStyle === 'tooltip' && _vm.caption) ? _c('l-marker', {
    attrs: {
      "lat-lng": _vm.center
    }
  }, [_c('l-tooltip', {
    attrs: {
      "options": {
        permanent: true,
        interactive: true,
        direction: this.tooltipDir
      }
    }
  }, [_c('div', {
    on: {
      "click": _vm.mapClick
    }
  }, [_vm._v("\n              " + _vm._s(_vm.caption) + "\n            ")])])], 1) : _c('l-marker', {
    attrs: {
      "lat-lng": _vm.center
    }
  }, [(_vm.caption) ? _c('l-popup', [_c('div', {
    on: {
      "click": _vm.mapClick
    }
  }, [_vm._v("\n              " + _vm._s(_vm.caption) + "\n            ")])]) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f0771b1c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/maps/LeafletMap.vue
// module id = 1653
// module chunks = 0